import AddCardIcon from '@mui/icons-material/AddCard';
import BlurOnIcon from '@mui/icons-material/BlurOn';
import CancelScheduleSendIcon from '@mui/icons-material/CancelScheduleSend';
import NotesOutlinedIcon from '@mui/icons-material/NotesOutlined';
import RedeemIcon from '@mui/icons-material/Redeem';
import {
	Avatar,
	Box,
	List,
	ListItem,
	ListItemAvatar,
	ListItemText,
	Typography,
} from '@mui/material';
import { ProductFieldValue } from 'components';
import { useTranslation } from 'react-i18next';
import { useBizLogicActions, useProduct } from 'stores';
import { ProductFieldType } from 'types';

const ProductInfoBox = () => {
	const product = useProduct();
	const { datetimeConversion } = useBizLogicActions();
	const { t, i18n } = useTranslation();

	const productFields = product ? product.fields : ([] as []);

	return (
		<>
			<Box pl={2} pr={2}>
				<List
					sx={{
						width: '100%',
						backgroundColor: 'productInfoBox.main',
						boxShadow: '1px -1px 10px 10px rgb(12 12 12 / 5%)',
						borderRadius: '15px 15px 15px 15px',
					}}
				>
					{Object.keys(product?.pointMsg || {}).length !== 0 ? (
						<>
							<ListItem>
								<ListItemAvatar
									sx={{
										justifyContent: 'center',
										display: 'flex',
									}}
								>
									{/* <Avatar> */}
									<AddCardIcon
										sx={{
											color: 'productInfoBox.text',
											width: '30px',
											height: '30px',
										}}
									/>
									{/* </Avatar> */}
								</ListItemAvatar>
								<ListItemText
									primary={
										<Typography
											sx={{
												color: 'productInfoBox.text',
												overflowWrap: 'break-word',
											}}
											variant="subtitle2"
										>
											{t('product.points.earned')}
										</Typography>
									}
									secondary={
										<Typography
											sx={{
												color: 'productInfoBox.text',
												overflowWrap: 'break-word',
											}}
											variant="body2"
										>
											{product?.pointMsg?.earnedPoint}
										</Typography>
									}
									sx={{ paddingLeft: '5%' }}
								/>
							</ListItem>
							<ListItem>
								<ListItemAvatar
									sx={{
										justifyContent: 'center',
										display: 'flex',
									}}
								>
									{/* <Avatar> */}
									<RedeemIcon
										sx={{
											color: 'productInfoBox.text',
											width: '30px',
											height: '30px',
										}}
									/>
									{/* </Avatar> */}
								</ListItemAvatar>
								<ListItemText
									primary={
										<Typography
											sx={{
												color: 'productInfoBox.text',
												overflowWrap: 'break-word',
											}}
											variant="subtitle2"
										>
											{t('product.points.total')}
										</Typography>
									}
									secondary={
										<Typography
											sx={{
												color: 'productInfoBox.text',
												overflowWrap: 'break-word',
											}}
											variant="body2"
										>
											{product?.pointMsg?.balancePoint}
										</Typography>
									}
									sx={{ paddingLeft: '5%' }}
								/>
							</ListItem>
							<ListItem>
								<ListItemAvatar
									sx={{
										justifyContent: 'center',
										display: 'flex',
									}}
								>
									{/* <Avatar> */}
									<CancelScheduleSendIcon
										sx={{
											color: 'productInfoBox.text',
											width: '30px',
											height: '30px',
										}}
									/>
									{/* </Avatar> */}
								</ListItemAvatar>
								<ListItemText
									primary={
										<Typography
											sx={{
												color: 'productInfoBox.text',
												overflowWrap: 'break-word',
											}}
											variant="subtitle2"
										>
											{t('product.points.expiry')}
										</Typography>
									}
									secondary={
										<Typography
											sx={{
												color: 'productInfoBox.text',
												overflowWrap: 'break-word',
											}}
											variant="body2"
										>
											{datetimeConversion(
												product?.pointMsg
													?.expirationDate,
												true
											)}
										</Typography>
									}
									sx={{ paddingLeft: '5%' }}
								/>
							</ListItem>
						</>
					) : null}
					<ListItem>
						<ListItemAvatar
							sx={{
								justifyContent: 'center',
								display: 'flex',
							}}
						>
							<Avatar
								sx={{ backgroundColor: 'productInfoBox.text' }}
							>
								<NotesOutlinedIcon
									sx={{ width: '25px', height: '25px' }}
								/>
							</Avatar>
							{/* <Avatar src={square} sx={{width:'50px', height:'50px'}}/> */}
						</ListItemAvatar>
						<ListItemText
							primary={
								<Typography
									sx={{ color: 'productInfoBox.text' }}
									variant="body1"
								>
									{t('product.productInfo')}
								</Typography>
							}
							sx={{ paddingLeft: '5%' }}
						/>
					</ListItem>
					{productFields.map((obj: ProductFieldType, idx: number) => (
						<ListItem key={idx} sx={{ alignItems: 'start' }}>
							<ListItemAvatar
								sx={{
									justifyContent: 'center',
									display: 'flex',
									paddingTop: '8px',
								}}
							>
								<BlurOnIcon
									sx={{
										color: 'productInfoBox.text',
										width: '35px',
										height: '35px',
										transform: 'rotate(90deg)',
									}}
								/>
							</ListItemAvatar>
							<ListItemText
								primary={
									<Typography
										sx={{
											color: 'productInfoBox.text',
											overflowWrap: 'break-word',
										}}
										variant="subtitle2"
									>
										{obj.name[i18n.resolvedLanguage]}
									</Typography>
								}
								secondary={
									<Typography
										sx={{
											color: 'productInfoBox.text',
											overflowWrap: 'break-word',
										}}
										variant="body2"
									>
										<ProductFieldValue {...obj} />
									</Typography>
								}
								sx={{ paddingLeft: '5%' }}
							/>
						</ListItem>
					))}
				</List>
			</Box>
		</>
	);
};

export default ProductInfoBox;
